import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  constructor(private keycloakservice: KeycloakService, private router: Router) { }

  user = '';
  async ngOnInit() {
    const userInfo = await this.keycloakservice.loadUserProfile();
    this.user = userInfo?.username || null;
  }

  logout(): void {
    this.keycloakservice.logout( environment.keyCloakRedirectUrl);
  }
  back() {
    this.router.navigate(['products']);
  }
}
